// Brain Superheroes universe — character data, colors, image assets
export const HEROES = {
  queen: {
    key: "queen",
    image:
      "https://customer-assets.emergentagent.com/job_c682c970-a160-4910-b01d-a3bd9510b215/artifacts/q2wo4ohn_file_0000000043e471f592f7faeae06ddb0a.png",
    accent: "#9333ea",
    accent2: "#f59e0b",
    gradient: "from-purple-700 via-fuchsia-600 to-amber-500",
    soft: "from-purple-100 via-fuchsia-50 to-amber-100",
    chip: "bg-purple-100 text-purple-800",
    ring: "ring-purple-400/50",
    bgGlow: "shadow-[0_30px_80px_-30px_rgba(147,51,234,0.55)]",
    imageBg: "bg-gradient-to-br from-purple-950 via-purple-800 to-fuchsia-900",
    activities: ["affirm", "reflect", "create"],
  },
  victor: {
    key: "victor",
    image:
      "https://customer-assets.emergentagent.com/job_c682c970-a160-4910-b01d-a3bd9510b215/artifacts/7h8dwqus_file_000000005914722fa7f5c25dd34222f5.png",
    accent: "#dc2626",
    accent2: "#f8fafc",
    gradient: "from-red-700 via-rose-600 to-slate-700",
    soft: "from-red-100 via-rose-50 to-slate-100",
    chip: "bg-red-100 text-red-800",
    ring: "ring-red-400/50",
    bgGlow: "shadow-[0_30px_80px_-30px_rgba(220,38,38,0.55)]",
    imageBg: "bg-gradient-to-br from-red-950 via-red-900 to-slate-900",
    activities: ["talk"],
  },
  cam: {
    key: "cam",
    image:
      "https://customer-assets.emergentagent.com/job_c682c970-a160-4910-b01d-a3bd9510b215/artifacts/6ff0rvjw_file_00000000e3c8722fbc65d840f5de114d.png",
    accent: "#2563eb",
    accent2: "#f59e0b",
    gradient: "from-blue-700 via-cyan-500 to-amber-400",
    soft: "from-blue-100 via-cyan-50 to-amber-100",
    chip: "bg-blue-100 text-blue-800",
    ring: "ring-blue-400/50",
    bgGlow: "shadow-[0_30px_80px_-30px_rgba(37,99,235,0.55)]",
    imageBg: "bg-gradient-to-br from-blue-950 via-blue-800 to-cyan-900",
    activities: ["breathe", "move"],
  },
};

export const HERO_ORDER = ["queen", "victor", "cam"];

export const heroForActivity = (activityKey) => {
  for (const h of HERO_ORDER) {
    if (HEROES[h].activities.includes(activityKey)) return HEROES[h];
  }
  return null;
};
